/**
 * Created by wajidafaneh on 29/01/2017.
 */
import {ClockoutAttestationAPI} from "../../../../../../apis/ClockoutAttestationAPI.js";
import {ATTESTATION_LANGUAGES} from "../../constants/custom-attestations.constants.js";
import {PENALTY_EXCEPTIONS_TYPES} from "../../constants/ct-timesheet-penalty-exceptions.constants.js";
import {ACTUAL_CLOCK_ACTION_VIOLATION_TYPE} from "../../../../../../hmodules/shared-clock-time/constants/actual-clock-time-management.constants.js";
import { ACTOR_TYPES, ENTRY_SOURCES } from "../../../../../../hmodules/team-live/breaks-management/constants/breaks-history.constants.js";
import { TCAF_EMPLOYEE_STATUSES } from "../../../../../../hmodules/team-live/breaks-management/constants/actual-breaks.constants.js";

(function (angular) {

    "use strict";

    angular
        .module('harriApp')
        .controller('CTEditShiftModalController', [
            "$scope",
            "$filter",
            "CTTimesheetService",
            "TeamScheduleService",
            "modalData",
            "onSave",
            "onReload",
            "TSUsersService",
            "userPermissions",
            "userServices",
            "TimesheetSettingsService",
            "businessDayUtils",
            "fairSchedulingService",
            "hUser",
            "ShiftTemplateUtils",
            "brandServices",
            "useManageCustomAttestationsFactory",
            "actualClockTimeManagementService",
            "jobTitlesDataService",
            "useTipsDistributionSharedFactory",
            "useIncentiveOpenShiftPaymentFactory",
            "useActualBreaksHelperFactory",
            "useBreaksWaiverFactory",
            "useBreaksHistoryFactory",
            function (
                $scope,
                $filter,
                CTTimesheetService,
                TeamScheduleService,
                modalData,
                onSave,
                onReload,
                TSUsersService,
                userPermissions,
                userServices,
                TimesheetSettingsService,
                businessDayUtils,
                fairSchedulingService,
                hUser,
                ShiftTemplateUtils,
                brandServices,
                useManageCustomAttestationsFactory,
                actualClockTimeManagementService,
                jobTitlesDataService,
                useTipsDistributionSharedFactory,
                useIncentiveOpenShiftPaymentFactory,
                useActualBreaksHelperFactory,
                useBreaksWaiverFactory,
                useBreaksHistoryFactory
            ) {

            const breaksHistoryFactory = useBreaksHistoryFactory();
            $scope.activeTab = modalData.activeTab || 'DETAILS';
            $scope.shift = modalData.shift;
            $scope.date = moment($filter("formatDateIgnoreTimeZone")(modalData.shift.date, "YYYY-MM-DD"));
            var formattedShiftDate = $scope.date.format('YYYY-MM-DD');
            const manageCustomAttestationsFactory = useManageCustomAttestationsFactory();
            $scope.breaksRulesSet = CTTimesheetService.getBreaksRulesSet(formattedShiftDate);
            $scope.clockTimeStatusReasonTrackingMode = CTTimesheetService.getClockTimeStatusReasonTrackingMode($scope.date);
            $scope.employee = modalData.employee;
            $scope.clockLoginSettings = modalData.clockLoginSettings;
            $scope.facialRecognitionEnabled = false;
            $scope.hasTimesheetOfflineConflict = modalData.shift && modalData.shift.has_timesheet_offline_conflict;
            $scope.PENALTY_TYPES = PENALTY_EXCEPTIONS_TYPES;
            $scope.ATTESTATION_LANGUAGES = ATTESTATION_LANGUAGES;
            $scope.isProcessing = false;
            $scope.error = null;
            $scope.warningtext = '';
            const isScheduledShift = !!$scope.shift.scheduled_shift;
            let policyParser;
            var selectedWeekLockStatus;
            
            $scope.onTimeChangeValidate = function (target) {
                return function (value) {
                    if (value && value.isValid()) {
                        if (value.isBefore(clockTimeMoment['clockIn'])) {
                            value.add(1, 'day');
                        }
                        if (value.isAfter(clockTimeMoment['clockOut'])) {
                            value.subtract(1, 'day');
                        }
                        if (target == 'from') {
                            if (value.isAfter(clockTimeMoment['clockOut'])) {
                                value = clockTimeMoment['clockIn'];
                            }
                        } else if (target == 'to') {
                            if (value.isBefore(clockTimeMoment['clockIn'])) {
                                value = clockTimeMoment['clockOut'];
                            }
                        }
                    }
                    return value;
                }
            };

            $scope.actionsMap = RecognitionAPI.RECOGNITION_ACTIONS;

            $scope.historyEntries = [];

            modalData.date = $scope.date.format("YYYY-MM-DD");
            modalData.timeSheeetAdjustmentSettings = CTTimesheetService.getTimeSheetAdjusmentsSettings();
            $scope.activeCallInsSettings = CTTimesheetService.getCallInsSettings( modalData.date);
            $scope.timeSheeetAdjustmentSettings = modalData.timeSheeetAdjustmentSettings;
            $scope.isTCAFLiteEnabled = $scope.timeSheeetAdjustmentSettings.tcaf_mode === 'LITE';

            if ($scope.timeSheeetAdjustmentSettings.is_clock_edit_reason_enabled) {
                $scope.EditCardReasons = CTTimesheetService.getBrandEditTimeCardReasons();
            }

            if (!$scope.employee.isDateWithinActiveLocationPeriod($scope.date)) {
                $scope.shift.is_editable = false;
                $scope.warningtext += $filter("translate")('You can’t restore a shift out of active location period') + '<br>';
                $scope.error = "OUT_OF_LOCATION_PERIOD";

                var latestLocationPeriod = $scope.employee.getLatestLocationPeriod();


                if (latestLocationPeriod) {
                    var formattedDate = moment($scope.date).format("YYYY-MM-DD");

                    if (
                        latestLocationPeriod.start_date &&
                        moment(formattedDate).isBefore(latestLocationPeriod.start_date, 'day')
                    ) {
                        $scope.activeLocationPeriodStartDate = latestLocationPeriod.start_date;
                    } else {
                        $scope.activeLocationPeriodEndDate = latestLocationPeriod.end_date;
                    }
                }
            }

            if (!$scope.employee.isDateWithinEmploymentPeriod($scope.date)) {
                $scope.shift.is_editable = false;
                $scope.shift.is_tips_editable = false;
                $scope.warningtext += $filter("translate")('You can’t restore a shift out of employment period') + '<br>';
                $scope.error = "OUT_OF_EMPLOYMENT_PERIOD";
            }

            if ($scope.employee.hasEffectiveLOA($scope.date)) {
                $scope.warningtext += $filter("translate")('Unable to restore timecard as ') + $scope.employee.first_name+ ' ' + $scope.employee.last_name + $filter("translate")(' is on leave of absence');
                $scope.error = "IN_ACTIVE_LOA_PERIOD";
            }

            $scope.isViewOnly = function () {
                return $scope.shift.isViewOnly;
            };

            $scope.editShiftForm = new CTManageShiftForm(
                $scope,
                $filter,
                CTTimesheetService,
                TeamScheduleService,
                modalData,
                userPermissions,
                userServices,
                TimesheetSettingsService,
                businessDayUtils,
                TSUsersService,
                hUser,
                ShiftTemplateUtils,
                brandServices,
                useTipsDistributionSharedFactory,
                actualClockTimeManagementService,
                jobTitlesDataService,
                useIncentiveOpenShiftPaymentFactory,
                useActualBreaksHelperFactory,
                useBreaksWaiverFactory
            );

            $scope.editShiftForm.onOverlappingBreaks (function (numberOfOverlappingBreaks) {
                $scope.isThereOverlapping = !!numberOfOverlappingBreaks;
            });

            var clockTimeMoment;

            const parseHistory = async (data, isScheduledShift, breaksHistoryTextVersionSettings, date) => {
                const allHistoryEntries = await Promise.all(data.map(async (entry) => {
                    const entryAttributes = [...entry.attributes];
                    const breakEditReasonAttribute = breaksHistoryFactory.parseClockEditReasonAttribute(entry.clock_edit_reason);
                    if (breakEditReasonAttribute) {
                        entryAttributes.push(breakEditReasonAttribute);
                    }

                    const processedEntry = {
                        ...entry,
                        attributes: entryAttributes,
                        sourceDisplay: breaksHistoryFactory.parseRecordSource(entry),
                        actor: breaksHistoryFactory.parseRecordActorName(entry.actor)
                    };

                    const attributes = breaksHistoryFactory.prepareHistoryAttributes(processedEntry, $scope.shift, $scope.employee, date, breaksHistoryTextVersionSettings);

                    processedEntry.parsedAttributes = await Promise.all(attributes.map(async (attribute) => {
                        if (
                            [
                                TCAF_EMPLOYEE_STATUSES.EMPLOYEE_PROTESTED, 
                                TCAF_EMPLOYEE_STATUSES.EMPLOYEE_APPROVED, 
                                TCAF_EMPLOYEE_STATUSES.EMPLOYEE_ACKNOWLEDGED
                            ].includes(attribute.to)
                        ) {
                            processedEntry.is_employee_message = true;
                        }
                        try {
                            const msgText = await CTTimesheetService.parseTimeCardHistoryEntry(
                                attribute, 
                                $scope.breaksRulesSet, 
                                $scope.clockTimeStatusReasonTrackingMode, 
                                isScheduledShift, 
                                processedEntry.source
                            );
                            return { text: msgText };
                        } catch (error) {
                            console.error(`Error parsing history entry for attribute ${attribute.attribute}:`, error);
                            return { text: `Error: ${attribute.attribute}` };
                        }
                    }));

                    return processedEntry;
                }));

                allHistoryEntries.reverse();

                const historyEntriesByDate = {};
                
                allHistoryEntries.forEach((entry) => {
                    // Skip empty TEAMHUB employee entries + entries without attributes
                    if (
                        (
                            entry.source === ENTRY_SOURCES.TEAMHUB && 
                            entry?.actor?.type === ACTOR_TYPES.EMPLOYEE && 
                            !entry.parsedAttributes?.length
                        ) ||
                        !entry.attributes?.length
                    ) {
                        return;
                    }
                    
                    const dateKey = moment($filter("formatDateIgnoreTimeZone")(entry.time, "YYYY-MM-DD"));
                    if (!historyEntriesByDate[dateKey]) {
                        historyEntriesByDate[dateKey] = [];
                    }
                    
                    historyEntriesByDate[dateKey].push(entry);
                });

                return Object.values(historyEntriesByDate);
            };

            const parseProtests = async (brandId, protestsMessages) => {
                try {
                    const userIdsToLoad = [];
                    protestsMessages.forEach((message) => {
                        const user = TSUsersService.users[message.user.id];
                        if (!user) {
                            userIdsToLoad.push(message.user.id);
                        } else {
                            message.user = user;
                        }
                    });

                    if (userIdsToLoad.length) {
                        await TSUsersService.loadUsers(brandId, userIdsToLoad);
                        protestsMessages.forEach((message) => {
                            message.user = TSUsersService.users[message.user.id];
                        });
                    }

                    return protestsMessages;
                } catch (error) {
                    hAlert({
                        title: 'Something went wrong!',
                        text: JSON.stringify(error)
                    });
                    throw error;
                }
            };

            const loadCustomAttestations = async (brandId, settingsType, attestationType, clockId, brandTimeZone) => {
                try {
                    $scope.isLoadingAttestations = true;
                    const attestations = await manageCustomAttestationsFactory.getCustomAttestations(brandId, settingsType, attestationType, clockId, brandTimeZone);
                    return attestations;
                } catch (error) {
                    console.error('Failed to load attestations:', error);                        
                    return [];
                } finally {
                    $scope.isLoadingAttestations = false;
                }
            }

            const loadAuditLogs = async (brandId, employeeId, clockId, requestDate, breaksHistoryTextVersionSettings, clockDate) => {
                try {
                    $scope.isLoadingHistory = true;
                    const historyRecords = await breaksHistoryFactory.getAuditLogs(brandId, employeeId, clockId, requestDate);
                    return await parseHistory(historyRecords.history || [], isScheduledShift, breaksHistoryTextVersionSettings, clockDate);
                } catch (error) {
                    console.error('Failed to load audit logs:', error);
                    return [];
                } finally {
                    $scope.isLoadingHistory = false;
                }
            }

            const loadLoginDetails = async (brandId, clockId, employee, clockLoginSettings, positionName, requestDate) => {
                try {
                    $scope.isLoadingLoginDetails = true;
                    const { employeeAttemptsResponse, historyRecords, loginSettings, managerInfoMap } = await getLoginDetails(
                        brandId, 
                        employee.id, 
                        clockId, 
                        requestDate,
                        clockLoginSettings
                    );

                    const canViewEmployeesPunchPhoto = policyParser.has(userPermissions.PERMISSIONS.VIEW_EMPLOYEES_PUNCH_PHOTOS);
                    $scope.employeeRecognitionAttempts = processTimecardAttemptDetails(
                        employeeAttemptsResponse.attempts,
                        positionName,
                        employee,
                        managerInfoMap
                    );
                    $scope.facialRecognitionEnabled = (
                        canViewEmployeesPunchPhoto && 
                        clockLoginSettings.allow_punch_photo_management && 
                        (
                            loginSettings?.employee_recognition_type === RecognitionAPI.ATTEMPTS_TYPES.FACIAL || 
                            loginSettings?.employer_approval_recognition_type === RecognitionAPI.ATTEMPTS_TYPES.FACIAL
                        )
                    );
                    $scope.isThereRecordsHiddenDueOffline = historyRecords.history?.some(entry => breaksHistoryFactory.checkForOfflineRecords(entry));
                } catch (error) {
                    console.error('Failed to load login details:', error);
                } finally {
                    $scope.isLoadingLoginDetails = false;
                }
            }

            $scope.onReasonToEditChanged = function () {
                if ($scope.editShiftForm.data.clockEditReason) {
                    $scope.editShiftForm.showReasonIsRequiredError = false;
                }
            };

            const processTimecardAttemptDetails = (attempts, positionName, employee, managerInfoMap) => {
                if (!attempts || !Array.isArray(attempts)) {
                    return [];
                }
                return attempts.map((attempt, index) => {
                    const processedAttempt = { ...attempt };
                    if (processedAttempt.employer_id && managerInfoMap[processedAttempt.employer_id]) {
                        const manager = managerInfoMap[processedAttempt.employer_id];
                        processedAttempt.user = `${manager.first_name} ${manager.last_name}`;
                    } else {
                        processedAttempt.user = `${employee.first_name} ${employee.last_name}`;
                    }
                    if (processedAttempt.blocker_mode === RecognitionAPI.ATTEMPTS_BLOCKER_MODES.BLOCKER) {
                        if (processedAttempt.employer_id) {
                            processedAttempt.isBlockerConfirmation = attempts[index - 1] && attempts[index - 1].confidence_type === RecognitionAPI.CONFIDENCE_TYPE.LOW;
                        }
                        processedAttempt.showUnsuccessfulConfirmationMessage = processedAttempt.confidence_type === RecognitionAPI.CONFIDENCE_TYPE.LOW;
                    }
            
                    processedAttempt.attemptText = CTTimesheetService.getTimeCardAttemptActionText(processedAttempt, positionName);
                    return processedAttempt;
                });
            };
            
            const loadManagerUserInfo = async (attempts, brandId) => {
                const managerIds = attempts.map(attempt => attempt.employer_id);
                return await TSUsersService.getUsersByIds(brandId, managerIds);
            };

            const [getLoginDetails, resetLoginDetailsCache] = cacheService.cache(async (brandId, employeeId, clockId, requestDate, clockLoginSettings) => {
                const promises = [
                    RecognitionAPI.getEmployeeTimeCardAttempts(brandId, employeeId, clockId),
                    breaksHistoryFactory.getAuditLogs(brandId, employeeId, clockId, requestDate)
                ];

                if (clockLoginSettings.allow_punch_photo_management) {
                    promises.push(TimesheetSettingsService.getClockLoginSettings());
                }

                const [employeeAttemptsResponse, historyRecords, loginSettings] = await Promise.all(promises);
                const managerInfoMap = await loadManagerUserInfo(employeeAttemptsResponse.attempts, brandId);

                return {
                    employeeAttemptsResponse,
                    historyRecords,
                    loginSettings,
                    managerInfoMap
                };
            });

            const [loadProtests, resetProtestsCache] = cacheService.cache(async (brandId, employeeId, clockId, requestDate) => {
                try {
                    $scope.isLoadingProtests = true;
                    const protestsMessages = await PerformanceAggregatorAPI.getClockProtestsMessages(brandId, employeeId, clockId, requestDate);
                    return await parseProtests(brandId, protestsMessages);
                } catch (error) {
                    console.error('Failed to load protests:', error);
                    return [];
                } finally {
                    $scope.isLoadingProtests = false;
                }
            });

            $scope.setActiveTab = async (tab) => {
                const requestDate = $scope.isExtendedFromPreviousDay ? $scope.date.clone().subtract(1, 'days') : $scope.date;
                $scope.activeTab = tab;
                switch (tab) {
                    case 'ATTESTATIONS':
                        $scope.attestations = await loadCustomAttestations(
                            modalData.brand.id, 
                            ClockoutAttestationAPI.ATTESTATION_SETTINGS_TYPES.CLOCK_OUT, 
                            ClockoutAttestationAPI.ATTESTATION_TEMPLATES_TYPES.CLOCK_OUT, 
                            $scope.shift.actual_clock.id,
                            modalData.brand.timezoneName
                        );
                        $scope.$digest();
                        break;
                    case 'HISTORY':
                        await $scope.setActiveHistoryTab('ALL');
                        break;
                    case 'LOGIN_DETAILS':
                        await loadLoginDetails(
                            modalData.brand.id,
                            modalData.shift.actual_clock.id,
                            modalData.employee,
                            $scope.clockLoginSettings,
                            $scope.shift.actual_clock.position.name,
                            requestDate.format("YYYY-MM-DD")
                        );
                        $scope.$digest();
                        break;
                    case 'PROTESTS':
                        $scope.protestsMessages = await loadProtests(
                            modalData.brand.id, 
                            modalData.employee.id, 
                            modalData.shift.actual_clock.id, 
                            requestDate.format("YYYY-MM-DD")
                        );
                        $scope.$digest();
                        break;
                }
            };

            $scope.setActiveHistoryTab = async (tab) => {
                $scope.activeHistoryTab = tab;
                switch (tab) {
                    case 'ALL':
                        const requestDate = $scope.isExtendedFromPreviousDay ? $scope.date.clone().subtract(1, 'days') : $scope.date;
                        $scope.auditLogsCache = await loadAuditLogs(
                            modalData.brand.id,
                            modalData.employee.id,
                            modalData.shift.actual_clock.id,
                            requestDate.format("YYYY-MM-DD"),
                            modalData.breaksHistoryTextVersionSettings,
                            $scope.date
                        );
                        $scope.$digest();
                        break;
                    case 'NOTES':
                        $scope.notesHistory = await loadNotesHistory(
                            modalData.brand.id,
                            modalData.employee.id,
                            modalData.shift.actual_clock.id
                        );
                        $scope.$digest();
                        break;
                }
            };

            const countProtests = (protestsMessages) => {
                return protestsMessages.filter(protest => 
                    protest.user.id === $scope.shift.employeeId
                ).length;
            };

            $scope.getTerminationDate = function () {
                var lastIndex = $scope.employee.employment_periods && $scope.employee.employment_periods.length - 1;
                if (lastIndex > -1) {
                    return $scope.employee.employment_periods[lastIndex].leave_date;
                }
            }

            $scope.isPenaltyExceptionsListDisable = function (penalty) {
                return CTTimesheetService.isPenaltyExceptionsListDisable(penalty) || !$scope.isEditable();
            };

            $scope.isUnresolved = function (penalty) {
                return CTTimesheetService.isUnresolved(penalty);
            };

            $scope.showException = function (penalty, penaltyType) {
                return CTTimesheetService.showException(penalty, penaltyType);
            };

            $scope.showSystemIgnore = function (penalty) {
                return (penalty.status === 'SYSTEM_IGNORED' && !penalty.isExceptionListDisabled);
            };

            $scope.isApproveClockDisabled = function () {
                return (
                    $scope.isThereOverlapping ||
                    $scope.isProcessing ||
                    $scope.countUnfixedWarnings() > 0 ||
                    $scope.editShiftForm.loadingBreaksInProgress ||
                    $scope.editShiftForm.shiftExtendedInLockedWeek() ||
                    $scope.editShiftForm.loading ||
                    $scope.editShiftForm.breaksSectionIsLoading ||
                    $scope.editShiftForm.breaksHaveWarnings() ||
                    $scope.editShiftForm.shiftExtendedInClosedPayPeriod() ||
                    $scope.hasTimesheetOfflineConflict ||
                    !$scope.editShiftForm.isNextDayWithinEmploymentPeriod() ||
                    ($scope.deletedShiftWithAutoConfirmPremium && ['OUT_OF_EMPLOYMENT_PERIOD', 'OUT_OF_LOCATION_PERIOD'].indexOf($scope.error) > -1) ||
                    ($scope.editShiftForm.isOverlappingWithOtherClocks && CTTimesheetService.getBlockOverlappingTimeCardsEnabled()) ||
                    $scope.editShiftForm.isGreaterThan24Hours ||
                    selectedWeekLockStatus === 'LOCKED' ||
                    $scope.editShiftForm.hasUnconfirmedBreak
                );
            };

            $scope.isPenaltyActionDisabled = function () {
                return (
                    $scope.shift.isExtendedFromPreviousDay ||
                    ['OUT_OF_EMPLOYMENT_PERIOD','OUT_OF_LOCATION_PERIOD'].indexOf($scope.error) > -1
                );
            };

            $scope.countUnfixedWarnings = function () {
                var count = 0;

                $scope.shift.actual_clock.penalties = $scope.shift.actual_clock.penalties || [];
                $scope.shift.actual_clock.penalties.forEach(function (penalty) {
                    if (penalty.ignore_reason && penalty.ignore_reason.code) {
                        penalty.originalIgnoreReason = penalty.originalIgnoreReason || penalty.ignore_reason.code;
                    }
                    if ($scope.isUnresolved(penalty)) {
                        count++;
                    }
                });

                if ($scope.shift.actual_clock &&
                    $scope.shift.actual_clock.call_in &&
                    $scope.shift.actual_clock.call_in.duration > 0 &&
                    $scope.isUnresolved($scope.shift.actual_clock.call_in)) {
                    count++;
                }

                $scope.shift.actual_clock.right_to_rest = $scope.shift.actual_clock.right_to_rest || [];
                $scope.shift.actual_clock.right_to_rest.forEach(function (penalty) {
                    if ($scope.isUnresolved(penalty)) {
                        count++;
                    }
                });

                return count;
            };

            $scope.refusePenalty = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyStatusUpdated($scope.shift.actual_clock.id, penalty.status,'IGNORED', penaltyId);
                CTTimesheetService.refusePenalty(penalty);
            };

            $scope.confirmPenalty = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyStatusUpdated($scope.shift.actual_clock.id, penalty.status,'APPROVED', penaltyId);
                CTTimesheetService.confirmPenalty(penalty);
            };

            $scope.unResolvePenalty = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyStatusUpdated($scope.shift.actual_clock.id, penalty.status,'PENDING_APPROVAL', penaltyId);
                penalty.status = "PENDING_APPROVAL";
            };

            $scope.penaltyExceptionChanged = function (penalty, type) {
                var penaltyId = type === 'CALL_IN' ? 'CALL_IN': penalty.id;
                $scope.editShiftForm.onPenaltyIgnoreReasonUpdated($scope.shift.actual_clock.id, penalty.originalIgnoreReason, penalty.ignore_reason && penalty.ignore_reason.code, penalty.status, penaltyId);
            };

                var getPenaltiesPayload = function () {
                    var payload = {};

                    if ($scope.shift.actual_clock.penalties && $scope.shift.actual_clock.penalties.length) {
                        payload.penalties = [];

                        for (var i in $scope.shift.actual_clock.penalties) {
                            var penalty = getPenalty($scope.shift.actual_clock.penalties[i]);
                            payload.penalties.push(penalty);
                        }
                    }

                    if ($scope.shift.actual_clock.right_to_rest && $scope.shift.actual_clock.right_to_rest.length) {
                        payload.right_to_rest = [];

                        for (var i in $scope.shift.actual_clock.right_to_rest) {
                            var penalty = getPenalty($scope.shift.actual_clock.right_to_rest[i]);
                            payload.right_to_rest.push(penalty);
                        }
                    }

                    if ($scope.shift.actual_clock.call_in && $scope.shift.actual_clock.call_in.duration > 0) {
                        payload.call_in = getPenalty($scope.shift.actual_clock.call_in);
                    }

                    return payload;
                };

                var getPenalty = function(penaltyDetails) {
                    var penalty = {
                        status: penaltyDetails.status,
                    };
                    if (penaltyDetails.id) {
                        penalty.id = penaltyDetails.id;
                    }

                    if (penaltyDetails.status === fairSchedulingService.PENALTY_STATUS.IGNORED) {
                        penalty.ignore_reason = {
                            id: penaltyDetails.ignore_reason.id
                        };
                    } else if (
                        penaltyDetails.status === fairSchedulingService.PENALTY_STATUS.SYSTEM_IGNORED && (
                            [
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.NEW_HIRE,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.FWW_24_HOUR_WINDOW,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.UNASSIGNED_SHIFT_PICKUP,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.INAPPLICABLE_SCHEDULED_RIGHT_TO_REST,
                            ].includes(penaltyDetails.system_ignore_eligibility_type)
                        )
                    ) {
                        penalty.ignore_reason = {
                            id: penaltyDetails.ignore_reason.id,
                            type: penaltyDetails.system_ignore_eligibility_type
                        };
                    } else if (penaltyDetails['ignore_reason'] && ['EMPLOYEE_REQUESTED', 'NON_COVERED'].indexOf(penaltyDetails['ignore_reason']['type']) > -1) {
                        penalty.ignore_reason = {
                            id: penaltyDetails.ignore_reason.id,
                            type: penaltyDetails['ignore_reason']['type']
                        };
                    }

                    return penalty;
                }

                var updateCallInIgnoreReason = function () {
                    if ($scope.shift.actual_clock.call_in &&
                        $scope.shift.actual_clock.call_in.duration > 0 &&
                        $scope.shift.actual_clock.call_in.status === 'IGNORED' &&
                        $scope.shift.actual_clock.call_in.ignore_reason) {

                        var ignoreReasonDetails = $scope.callInIgnoreReasons.find(function (reason) {
                            return reason.id === $scope.shift.actual_clock.call_in.ignore_reason.id;
                        })
                        if (ignoreReasonDetails) {
                            $scope.shift.actual_clock.call_in.ignore_reason = ignoreReasonDetails;
                        }

                    }

                }

            var updateClockData = function (clock) {

                $scope.shift = clock;
                updateCallInIgnoreReason($scope.shift.actual_clock.call_in);
                attachPenaltiesDetails();
            };

            var getNewPenalties = function (clock) {
                var newPenalties = clock.actual_clock.penalties || [];
                var newRightToRestPenalties = clock.actual_clock.right_to_rest || [];
                var newCallInPenalty = clock.actual_clock.call_in || {};

                return {
                    penalties: newPenalties,
                    right_to_rest: newRightToRestPenalties,
                    call_in: newCallInPenalty
                }
            };

            var hasNewPenalties = function (clock) {
                var penaltiesData = getNewPenalties(clock);
                var newPenalties = penaltiesData.penalties;
                var newRightToRestPenalties = penaltiesData.right_to_rest;
                var newCallInPenalty = penaltiesData.call_in;

                if (
                    $scope.shift.actual_clock.penalties.length !== newPenalties.length ||
                    $scope.shift.actual_clock.right_to_rest.length !== newRightToRestPenalties.length
                ) {
                    return true
                }

                for (var i in $scope.shift.actual_clock.penalties) {
                    var item = _.find(newPenalties, {id: $scope.shift.actual_clock.penalties[i].id});

                    if (!item || item.status !== $scope.shift.actual_clock.penalties[i].status) {
                        return true;
                    }
                }

                for (var i in $scope.shift.actual_clock.right_to_rest) {
                    var item = _.find(newRightToRestPenalties, {id: $scope.shift.actual_clock.right_to_rest[i].id});

                    if (!item || item.status !== $scope.shift.actual_clock.right_to_rest[i].status) {
                        return true;
                    }
                }
                var isCallInEmpty = Object.keys($scope.shift.actual_clock.call_in).length === 0;
                var isNewCallInPenaltyEmpty = Object.keys(newCallInPenalty).length === 0;

                if (
                    (isCallInEmpty && newCallInPenalty.duration > 0) ||
                    (isNewCallInPenaltyEmpty && $scope.shift.actual_clock.call_in.duration > 0) ||
                    $scope.shift.actual_clock.call_in.duration !== newCallInPenalty.duration
                ) {
                    return true;
                }

                return false;
            };

            $scope.switchEnableForm = function () {
                $scope.shift.is_editable = true;

                if (
                    $scope.timeSheeetAdjustmentSettings.employee_protest_enabled &&
                    $scope.timeSheeetAdjustmentSettings.is_clock_edit_reason_enabled
                ) {
                    $scope.editShiftForm.toggleTimeCardChanged();
                }
            };

            $scope.approve = function (mode) {
                if(
                    modalData.brand.services.indexOf('TIPS_DISTRIBUTION') > -1 &&
                    $scope.shift.is_tipped &&
                    $scope.editShiftForm.data.position.id !== $scope.shift.actual_clock.position.id &&
                    !$scope.editShiftForm.data.position.position_settings['is_tipped']
                ) {
                    hConfirm({
                        title: $filter("translate")("Confirm Edit"),
                        text: $filter("translate")("The applied edit will remove the distributed tips for ") +
                                                    $scope.employee.first_name + " " + $scope.employee.last_name +
                                                    $filter("translate")(", confirm to proceed."),
                        confirmButton: $filter("translate")("Confirm"),
                        cancelButton: $filter("translate")("Cancel"),
                        callback: function (confirmed) {
                            if (confirmed) {
                                updateForm(true, mode);
                            }
                        }
                    });
                } else {
                    updateForm(false, mode);
                }
            };

            var updateForm = function (removeTips, mode) {
                $scope.isProcessing = true;
                $scope.error = null;
                var updatePromise = {};

                if (mode === 'UPDATE_TIPS_ONLY') {
                    updatePromise['updateTips'] = $scope.editShiftForm.updateExtendedTips(removeTips);
                } else {
                    var penaltiesData = getPenaltiesPayload();
                    updatePromise['save'] = $scope.editShiftForm.save(removeTips, penaltiesData);
                }

                $q.all(updatePromise)
                    .then(function (res) {
                        $scope.isProcessing = false;
                        $scope.editShiftForm.resetTimeCardChanged();

                        var data = CTTimesheetService.getData();
                        var extendedClockIndex = _.findIndex(data.clocks, function (clock) {
                            return (clock.actual_clock.id === $scope.shift.actual_clock.id && clock.isExtendedFromPreviousDay)
                        });

                        if (extendedClockIndex > -1 && mode !== 'UPDATE_TIPS_ONLY') {
                            data.clocks.splice(extendedClockIndex, 1);
                        }

                        var promise = onSave(res['save'], mode === 'UPDATE_TIPS_ONLY');
                        if (promise) {
                            promise
                                .then(function () {
                                    var clock = data.clocks.find(function (clock) {
                                        return clock.actual_clock.id === $scope.shift.actual_clock.id
                                    });
                                    if (hasNewPenalties(clock)) {
                                        updateClockData(clock);
                                        $scope.editShiftForm.updateShift($scope.shift);
                                        $scope.error = "PENALTIES_UPDATED";
                                        $scope.setActiveTab('WARNINGS')
                                    } else {
                                        actualClockTimeManagementService.checkForTimeCardActionViolations(res['save'].warnings, modalData.employee.id, () => {
                                            $scope.hideModal();
                                        });
                                    }
                                });
                        } else {
                            $scope.hideModal();
                        }
                    }, function (err) {
                        $scope.isProcessing = false;

                        //in case it's a front-end validation error, then most likely it will be in details page
                        //switch the view to details page
                        if (err && err.type === "FE_VALIDATION_ERROR") {
                            $scope.setActiveTab("DETAILS");
                        } else if (err && err.data && err.data.errors && err && err.data && err.data.errors) {
                            var errors = err.data.errors;
                            if ([
                                    //Errors related to time entry
                                    "CLOCK_ENTRY_ALREADY_APPROVED",
                                    "CLOCK_ENTRY_DELETED",
                                    "SHIFT_NOT_FOUND",
                                    //Errors related to paysheet
                                    "PAYSHEET_CLOSED",
                                    //Un-Authorized
                                    "UNAUTHORIZED_CATEGORY",
                                    //errors related to breaks
                                    "BREAK_IS_DELETED",
                                    "BREAK_IS_ADDED_TO_PAY_TIME",
                                    "BREAK_IS_IGNORED",
                                    //general excecptions
                                    "OPTIMISTIC_LOCK_EXCEPTION",
                                ].indexOf(errors[0].code) > -1) {
                                if (errors[0].code === "UNAUTHORIZED_CATEGORY") {
                                    $scope.error = "UNAUTHORIZED_CATEGORY";
                                } else {
                                    $scope.error = "UPDATED_TIMECARD";
                                }
                            } else if (errors[0].code === 'OVERLAPPING_TIMECARDS') {
                                $scope.hasOverlappingError = true;
                            } else if (errors[0].detail?.[ACTUAL_CLOCK_ACTION_VIOLATION_TYPE.RIGHT_TO_REST]) {
                                actualClockTimeManagementService.checkForTimeCardActionViolations(errors[0].detail, modalData.employee.id);
                            } else {
                                console.error("error while trying to process your request, please send the following error to our tech team!", err);
                            }
                        } else {
                            console.error("error while trying to process your request, please send the following error to our tech team!", err);
                        }

                        setTimeout(function () {
                            $scope.$digest();
                        }, 1);
                    });
            };

                var disablePenaltyExceptionsList = function (penalty) {
                    return (
                        penalty.ignore_reason &&
                        (
                            [
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.VOLUNTARY_STANDBY_LIST,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.NEW_HIRE,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.NON_COVERED,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.EMPLOYEE_REQUESTED,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.FWW_24_HOUR_WINDOW,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.MASS_COMMUNICATION,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.UNASSIGNED_SHIFT_PICKUP,
                                fairSchedulingService.PENALTY_SYSTEM_IGNORE_ELIGIBILITY_TYPE.INAPPLICABLE_SCHEDULED_RIGHT_TO_REST,
                            ].includes(penalty.ignore_reason.type)
                        )
                    );
                };

            const attachPenaltiesDetails = async () => {
                try {
                    const rules = await fairSchedulingService.getPenaltiesRules();
                    
                    for (const penalty of $scope.shift.actual_clock.penalties) {
                        const rule = rules.find((item) => item.id === penalty.rule_id);
                        penalty.isExceptionListDisabled = disablePenaltyExceptionsList(penalty);
                        if (rule) {
                            penalty.ruleDetails = rule;
                            penalty.penaltyDetails = fairSchedulingService.getPenaltyDetails(penalty, rule);
                        } else {
                            console.error("can't find rule", penalty.rule_id)
                        }
                    }

                    for (const rtrPenalty of $scope.shift.actual_clock.right_to_rest) {
                        const rule = rules.find((item) => item.id === rtrPenalty.rule_id);
                        rtrPenalty.isExceptionListDisabled = disablePenaltyExceptionsList(rtrPenalty);

                        if (rule) {
                            rtrPenalty.ruleDetails = rule;
                            rtrPenalty.penaltyDetails = fairSchedulingService.getPenaltyDetails(rtrPenalty, rule);
                        } else {
                            console.error("can't find rule", rtrPenalty.rule_id)
                        }
                    }
                } catch (err) {
                    console.error(err);
                    throw err;
                }
            };

            const loadNotesHistory = async (brandId, employeeId, clockId) => {
                try {
                    $scope.isLoadingHistory = true;
                    const notes = await breaksHistoryFactory.getNotesHistory(brandId, employeeId, clockId);
                    const managerIds = notes.map(note => note.created_by?.id);
                    const managerInfoMap = await TSUsersService.getUsersByIds(brandId, managerIds);
                    return breaksHistoryFactory.parseNotesHistory(notes, managerInfoMap);
                } catch (err) {
                    console.error('Failed to load notes history:', err);
                } finally {
                    $scope.isLoadingHistory = false;
                }
            };

            $scope.getFormattedChangeValue = function (value) {
                return CTTimesheetService.getPremiumFormattedChangeValue(value);
            };

            $scope.isEditable = function () {
                return !$scope.shift || ($scope.shift.is_editable && !$scope.shift.isViewOnly);
            };

            $scope.isRestoreButtonShown = function () {
                return (
                    $scope.shift &&
                    $scope.shift.status === 'DELETED' &&
                    !$scope.shift.isExtendedFromPreviousDay &&
                    !$scope.shift.isViewOnly
                );
            };

            $scope.isRTRPenaltyExceptionDisabled = (penalty) => {
                return (
                    !$scope.editShiftForm.isFormEditable() ||
                    !$scope.canResolveRTRPenaltyAsException ||
                    CTTimesheetService.isPenaltyExceptionsListDisable(penalty)
                );
            };

            //Trigger the re-load call
            $scope.reloadTimesheet = function () {
                onReload();
                $scope.hideModal();
            };

            //Hide modal
            $scope.hideModal = function () {
                CTTimesheetService.resetClockRightToRestAudit();
                resetLoginDetailsCache();
                resetProtestsCache();
                $scope.$hide();

                setTimeout(function () {
                    $scope.$digest();
                }, 1);
            };

            var mapPenaltiesReasons = function (penalties, premiumPayIgnoreReasons) {
                for (var i in penalties) {
                    var penalty = penalties[i];
                    if (['IGNORED', 'SYSTEM_IGNORED'].indexOf(penalty['status']) > -1 && penalty['ignore_reason']) {
                        var ignoreReason = _.findWhere(premiumPayIgnoreReasons, {id: penalty['ignore_reason'].id});
                        if (!ignoreReason) {
                            ignoreReason = _.findWhere($scope.finalFWWIgnoreReasons, {id: penalty['ignore_reason'].id});
                        }
                        penalty['ignore_reason']['name'] = ignoreReason['name'];
                        penalty['ignore_reason']['status'] = ignoreReason['status'];
                    }
                }
            };

                $scope.onOptionSelect = function (target) {
                    return function (option) {
                        var metaObj = {};
                        if (option.next_day) {
                            metaObj.appendText = $filter('translate')('Next Day');
                            metaObj.prependIcon = 'next-day-icon';
                        } else {
                            metaObj.appendText = '';
                            metaObj.prependIcon = '';
                        }

                        $scope.shift.warnings[target + '_meta'] = metaObj;
                    }
                };

                $scope.onFromTimeChange = function (value) {
                    if (value) {
                        var to = clockTimeMoment['clockOut'] || $scope.businessDayLimits.closeTime;
                        $scope.endTimeOptions = hTimePickerUtils.getIntervalOptions({
                            from: value,
                            to: to,
                            withInfo: true,
                            minutesPeriod: 15,
                            includeFrom: false,
                            includeTo: true,
                            closeTimeWithoutExtension: $scope.businessDayLimits.closeTimeWithoutExtension
                        })
                    } else {
                        $scope.endTimeOptions = [];
                    }
                };

            const mapPenaltiesConsentDetails = (penalties, consents, rightToRestPenalty) => {
                for (const i in penalties) {
                    const penalty = penalties[i];
                    let premiumKey = 'penalty';

                    if (rightToRestPenalty) {
                        premiumKey = 'right_to_rest';
                    }

                    $scope.mappedPenalties[premiumKey] ??= {};
                    $scope.mappedPenalties[premiumKey][penalty.id] = {};

                    if (rightToRestPenalty) {
                        const rightToRestConsents = consents.filter(consent => consent?.premiums?.right_to_rest?.length);
                        rightToRestConsents.sort((consent1, consent2) => new Date(consent2.final_status_date) - new Date(consent1.final_status_date));

                        if (rightToRestConsents[0]) {
                            $scope.mappedPenalties[premiumKey][penalty.id].consents ??= [];
                            $scope.mappedPenalties[premiumKey][penalty.id].consents.push({
                                consent_status: rightToRestConsents[0].status,
                                consented_on : rightToRestConsents[0].final_status_date,
                                request_reason : rightToRestConsents[0].requested_reason,
                                consent_source : rightToRestConsents[0].actor_source,
                                isClockOutConsent: rightToRestConsents[0].isUnscheduled && rightToRestConsents[0].status === 'SYSTEM_REJECTED',
                            });
                        }
                    } else {
                        for (const j in consents) {
                            const consent = consents[j];

                            const consentPenalties = consent?.premiums?.penalties;
                            const consentPenalty = consentPenalties?.find(consentPenalty => consentPenalty.id === penalty.id);

                            if (consentPenalty) {
                                $scope.mappedPenalties[premiumKey][penalty.id].consents ??= [];
                                $scope.mappedPenalties[premiumKey][penalty.id].consents.push({
                                    consent_status: consent.status,
                                    consented_on : consent.final_status_date,
                                    request_reason : consent.requested_reason,
                                    consent_source : consent.actor_source,
                                    isClockOutConsent: consent.isUnscheduled && consent.status === 'SYSTEM_REJECTED',
                                });
                            }
                        }
                    }
                }
            };

            var attachConsentPenaltyDetails = function () {
                var clockId = modalData.shift.actual_clock && modalData.shift.actual_clock.id;
                var shiftId = modalData.shift && modalData.shift.scheduled_shift && modalData.shift.scheduled_shift.id;
                var isScheduled = !!shiftId;

                CTTimesheetService
                    .getEmployeeClockConsentDetails(modalData.brand.id, clockId, shiftId, isScheduled)
                    .then(function (consents) {
                        consents.sort(function (a, b) {
                            return new Date(a.final_status_date) - new Date(b.final_status_date)
                        })
                        mapPenaltiesConsentDetails($scope.shift.actual_clock.penalties, consents);
                        mapPenaltiesConsentDetails($scope.shift.actual_clock.right_to_rest, consents, true);
                    });
            };

            const setBrandJobTitles = async () => {
                const isJobTitleSkillLevelServiceEnabled = await brandServices.check(brandServices.SERVICES.JOB_TITLE_SKILL_LEVEL, modalData.brand.id);
                if (isJobTitleSkillLevelServiceEnabled) {
                    const brandJobTitles = await BrandAPI.getBrandJobTitlesWithRestrictedPositions(modalData.brand.id);
                    jobTitlesDataService.setBrandJobTitles(brandJobTitles.job_titles || []);
                }
            }

            //Init
            (function () {
                $scope.loadingTimeCard = true;
                $scope.shift.actual_clock.penalties = $scope.shift.actual_clock.penalties || [];
                $scope.shift.actual_clock.right_to_rest = $scope.shift.actual_clock.right_to_rest || [];
                $scope.mappedPenalties = {right_to_rest: {}, penalty: {}};
                $scope.callInIgnoreReasons = [];
                var hasAutoConfirmPremium = $scope.shift.actual_clock.penalties.find(function(penalty) {
                    return penalty.status == 'SYSTEM_APPROVED';
                });

                $scope.deletedShiftWithAutoConfirmPremium = ($scope.shift.category == 'SCHEDULED_DELETED') && hasAutoConfirmPremium;

                const promisesToLoad = {};
                promisesToLoad['policyParser'] = userPermissions.getBrandPolicy(modalData.brand.id);
                promisesToLoad['ignore_reasons'] = TimesheetSettingsService.getPremiumPayIgnoreReasons();
                promisesToLoad['final_fww_reasons'] = TimesheetSettingsService.getFinalFWWExceptions();                
                promisesToLoad['has_clockout_attestation_service'] = brandServices.check(brandServices.SERVICES.CLOCK_OUT_ATTESTATION_QUESTIONS, modalData.brand.id);
                if ($scope.activeCallInsSettings && $scope.activeCallInsSettings !== "NONE") {
                    promisesToLoad['call_in_ignore_reasons'] = TimesheetSettingsService.getCallInIgnoreReasons();
                }
                promisesToLoad["set_brand_job_titles"] = setBrandJobTitles();
                if ($scope.shift.actual_clock.right_to_rest.length) {
                    var clockId = modalData.shift.actual_clock && modalData.shift.actual_clock.id;
                    var shiftId = modalData.shift && modalData.shift.scheduled_shift && modalData.shift.scheduled_shift.id;
                    var isScheduled = $scope.shift.actual_clock.right_to_rest[0].source === 'FORECAST';
                    var rtrId = $scope.shift.actual_clock.right_to_rest[0].id;

                    promisesToLoad['clock_right_to_rest_audit'] = CTTimesheetService.getClockRightToRestAudit(modalData.brand.id, modalData.employee.id, rtrId, clockId, shiftId, isScheduled);
                }

                var businessDay = TeamScheduleService.getBusinessDay();
                $scope.businessDayLimits = businessDayUtils.getBusinessDayLimits(businessDay, formattedShiftDate);
                var selectedWeekLockStatusDetails = CTTimesheetService.getTimesheetLockStatuses('CURRENT_WEEK');
                selectedWeekLockStatus = selectedWeekLockStatusDetails && selectedWeekLockStatusDetails.isLocked ? 'LOCKED' : 'UNLOCKED';

                $q.all(promisesToLoad)
                    .then(async (res) => {
                        $scope.currency = "$";
                        policyParser = res.policyParser;
                        $scope.brandTimeZone = modalData.brand.timezoneName;
                        var premiumPayIgnoreReasons = angular.copy(res['ignore_reasons'] && res['ignore_reasons'].error_reasons) || [];
                        $scope.premiumPayIgnoreReasons = _.filter(premiumPayIgnoreReasons, {status: 'ACTIVE'});
                        var finalFWWIgnoreReasons = angular.copy(res['final_fww_reasons'] && res['final_fww_reasons'].error_reasons) || [];
                        $scope.finalFWWIgnoreReasons = _.filter(finalFWWIgnoreReasons, {status: 'ACTIVE'});
                        $scope.hasClockoutAttestationService = res['has_clockout_attestation_service'];

                        if (res['clock_right_to_rest_audit']) {
                            $scope.shift.actual_clock.right_to_rest[0].clock_source = res['clock_right_to_rest_audit'].clock_source;
                        }

                        if (res['call_in_ignore_reasons']) {
                            var callInIgnoreReasons = angular.copy(res['call_in_ignore_reasons'] && res['call_in_ignore_reasons'].error_reasons) || [];
                            $scope.callInIgnoreReasons = callInIgnoreReasons.filter(function (reason) {
                                return (reason.status == 'ACTIVE') && (reason.call_in_type === $scope.activeCallInsSettings);
                            });
                        }

                        $scope.canResolveRTRPenaltyAsException = policyParser.has(userPermissions.PERMISSIONS.RESOLVE_RTR_PENALTY_AS_EXCEPTION);
                        $scope.canViewClockoutAttestation = policyParser.has(userPermissions.PERMISSIONS.VIEW_CLOCK_OUT_ATTESTATION_ANSWERS);

                        if ($scope.shift.actual_clock?.penalties?.length || $scope.shift.actual_clock?.right_to_rest?.length) {
                            await attachPenaltiesDetails();
                        }

                        attachConsentPenaltyDetails();

                        mapPenaltiesReasons($scope.shift.actual_clock.penalties, premiumPayIgnoreReasons);
                        mapPenaltiesReasons($scope.shift.actual_clock.right_to_rest, premiumPayIgnoreReasons);

                        if ($scope.timeSheeetAdjustmentSettings.employee_protest_enabled) {
                            const requestDate = $scope.isExtendedFromPreviousDay ? $scope.date.clone().subtract(1, 'days') : $scope.date;
                            loadProtests(
                                modalData.brand.id, 
                                modalData.employee.id, 
                                modalData.shift.actual_clock.id, 
                                requestDate.format("YYYY-MM-DD")
                            ).then((protestsMessages) => {
                                $scope.protestsMessages = protestsMessages;
                                $scope.numberOfProtests = countProtests(protestsMessages);                                
                                $scope.$digest();
                            }).catch((error) => {
                                console.error('Failed to load protests on init:', error);
                            });
                        }

                        $scope.loadingTimeCard = false;
                        $scope.$digest();
                    }, function (err) {
                        var alertOptions = {
                            title: 'Something went wrong!',
                            text: JSON.stringify(err)
                        };

                        hAlert(
                            alertOptions
                        );
                    });
            })();
        }]);

})(angular);
